import React,{useEffect,useState,useRef} from 'react';
import { Link } from 'react-router-dom'
import { Form, Container, Row, Col } from "react-bootstrap";
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import Axios from '../../lib/axios/axiosInstance';
import * as Yup from "yup";
import {BASE_URL} from '../../lib/constant';
import { Formik } from "formik";
import { Space, Table } from 'antd';
import InputField from "../InputField/InputField";
import SlectInputField from "../SlectInputField";
import { Flip, Slide, toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
// import 'antd/dist/antd.css';
import 'antd/dist/antd.min.css';
import { data } from 'jquery';

const validationSchema = Yup.object().shape({
  budgettype: Yup.string().min(2).required("Budget Type is required"),
  budgetdesc: Yup.string().min(2).max(25).required("Budget description is required"),
  // email: Yup.string().email("Email is invalid").required("Email is required"),
  limitscheme: Yup.string().required("limit is required"),
  enddate: Yup.string().required("End Date is required"),
  effdate: Yup.string().required("Start Date is required")
});

function monthDiff(d1, d2) {
  var months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}

const initialValue = {
};

const budgetTypes = [
  {label:"PO",value:"PO"},
  {label:"Non-PO",value:"NONPO"}
];
const limitSchemes=[
  {label:"Monthly",value:"monthly"},
  {label:"Lump sum",value:"lumpsum"}
];

const BudgetDetails = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [newEntry, setNewEntry] = useState(false);
    const [formValue, setFormValue] = useState(false);
    const [budgetDetails, setBudgetDetails] = useState(false);
    const [breakDowns, setBreakDowns] = useState(false);
    const [catalogs, setCatalogs] = useState([]);
    const [costcenter, setCostcenter] = useState([]);
    const [periods, setPeriods] = useState([]);
    const [period, setPeriod] = useState(false);
    const [periodDetails, setPeriodDetails] = useState(false);
    const [selectedLimitScheme, setSelectedLimitScheme] = useState(false);
    const [startEndDate, setStartEndDate] = useState(false);
    const [cfAmount, setCfAmount] = useState(0);
    const initial = useRef();
    const previousValue = useRef();

    const [editPermission, setEditPermission] = useState(false);
    const [deletePermission, setDeletePermission] = useState(false);
    const [viewPermission, setViewPermission] = useState(false);
    const [addNewPermission, setAddNewPermission] = useState(false);


    const getBudgetDetails = async () => {
      const user=AuthVerify.getUser();
      if(user){
        // Get Budget Details
        // api/corporate/budget/ARM-22000075/BGT0000H7YT48NNA
        const budgetnum=searchParams.get("budgetnum");
        await Axios.get(`/corporate/budget/${user.arnum}/${budgetnum}`)
        .then(function (response) {
            if (response && response.data?.data) {
              var responseBudgetData=response.data?.data.budget;
              responseBudgetData.effdate=responseBudgetData.effdate.split('T')[0]
              responseBudgetData.enddate=responseBudgetData.enddate.split('T')[0]
              setBudgetDetails(response.data?.data);
              setFormValue(responseBudgetData);
              setSelectedLimitScheme(response.data?.data.budget.limitscheme);
              setStartEndDate({startDate: response.data?.data.budget.effdate,endDate: response.data?.data.budget.enddate})
              initial.current=true;
            }
            else {
              setBudgetDetails([]);
            }
        })
        .catch(function (error) {
          setBudgetDetails([]);
        });
      }
    };
    
    const dateChangeEvent= (startDate,endDate,value) => {
      //setNewEntry(true);
      if(startDate){
        var data = startEndDate;
        if(!data)data = {};
        data.startDate=value;
        setStartEndDate(data)
      }else if(endDate){
        var data = startEndDate;
        if(!data)data = {};
        data.endDate=value;
        setStartEndDate(data)
      }
    }

    useEffect(async () => {
      if(searchParams.get("budgetnum")){
        getBudgetDetails();
      }else{
        setNewEntry(true);
        setFormValue(initialValue);
      }
    }, [searchParams])

    useEffect(async () => {
      const user = AuthVerify.getUser();
      if(user){
        const permission =AuthVerify.getPermissions("Budget");
        setViewPermission(permission?.view);
        setEditPermission(permission?.edit);
        setDeletePermission(permission?.delete);
        setAddNewPermission(permission?.addnew);
      }
      await Axios.get(`/corporate/catalog/${user.arnum}`)
      .then(async (catalogs) => {
          if (catalogs.status == 200 && catalogs.data?.data?.catalogs) {
            var catalogdd=[];
            catalogs.data?.data?.catalogs.forEach(element => {
              catalogdd.push({label: element.catalogname,value:element.catalognum})
            });
            setCatalogs(catalogdd);
          }
      })
      await Axios.get(`/corporate/costcenter/${user.arnum}`)
      .then(async (costcenters) => {
        if (costcenters.status == 200 && costcenters.data?.data?.costcenters) {
          var costcenterdd=[];
          costcenters.data?.data?.costcenters.forEach(element => {
            costcenterdd.push({label: element.ccname,value:element.ccnum})
          });
          setCostcenter(costcenterdd);
        }
    })
    }, [])

    useEffect(async () => {
      if(period && period.length < 10){
        budgetDetails.breakdown.forEach(element => {
          let date=new Date(element.effdate);
          let year=date.getFullYear();
          let month=date.getMonth()+1;
          if(period==`${month}/${year}`){
            setPeriodDetails(element);
            setCfAmount(element.cf_totalamount??0);
            return;
          }
        });
      }else{
        setPeriodDetails([]);
      }
    }, [period])
    
    const updateFormSubmitHandler = async (values) => {
      const breakDownData =[];
      let totalAmount=0;
      const budgetnum=newEntry?"":budgetDetails.budget?.budgetnum;
      if(breakDowns && breakDowns.length > 0){
        breakDowns.map((item,index)=>{
          totalAmount+=parseInt(item.totalamount==''?0:item.totalamount);
          breakDownData.push({
            budgetnum: budgetnum,
            effdate: item.effdate,
            enddate: item.enddate,
            totalamount: item.totalamount
          });
        })
      }else{
        totalAmount=values.totalamount
        breakDownData.push({
          budgetnum: budgetnum,
          effdate: values.effdate,
          enddate: values.enddate,
          totalamount: values.totalamount
        });
      }
      if(totalAmount<1){
        toast.error(`Total amount must be greater then Zero !`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Slide,
        });
        return;
      }
      // let totalAmount = breakDowns.reduce((accumulator, object) => {
      //   return accumulator + parseInt(object.totalamount??0);
      // }, 0);
      const user = AuthVerify.getUser();
      const data={
        budget: {
            budgetnum: budgetnum,
            budgetdesc: values.budgetdesc,
            arnum: user.arnum,
            budgettype: values.budgettype,
            catalognum: values.catalognum??null,
            ponum: values.ponum??"",
            effdate: values.effdate,
            enddate: values.enddate,
            totalamount: totalAmount,
            limitscheme: values.limitscheme,
            ccnum: values.ccnum??null,
        },
        breakdown: breakDownData
      }

      // Update Budget
      // api/corporate/budget/
      await Axios.post(`/corporate/budget/${user.arnum}`,data)
        .then(function (response) {
            if (response && response.data?.data) {
              if(response.data?.data.breakdown.length===breakDownData.length){
                setNewEntry(false);
                setBudgetDetails(response.data?.data);
                toast.success(`Budget ${newEntry?'created':'updated'} successfully.`, {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 3000,
                  transition: Slide,
                });
                // navigate('/my-account?activeKey=Budget')
              }
              else{
                toast.error(`Budget update failed !.`, {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 3000,
                  transition: Slide,
                });
              }
            }
            else {
              toast.error(`Budget update failed !. Error:${response.data?.error?.hint??response.data?.error?.detail}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
              });
            }
        })
        .catch(function (error) {
          setBudgetDetails([]);
        });
    }

    const budgetAmountChangeEvent = (mmyyyy,amount) =>{
      if(breakDowns.length>0){
        var data = breakDowns;
        data.map(item => {
          if(item.mmyyyy===mmyyyy){
            item.totalamount=amount;
          }
          else if(mmyyyy===false){
            item.totalamount=amount;
          }
        })
        setBreakDowns(data); 
      }else{
        const values={startDate:startEndDate.startDate,endDate:startEndDate.endDate,totalamount:formValue.totalamount};
        var data=budgetBreakDowns(values,mmyyyy===false);
        data.map(item => {
          if(item.mmyyyy===mmyyyy){
            item.totalamount=amount;
          }
          else if(mmyyyy===false){
            item.totalamount=amount;
          }
        })
        setBreakDowns(data); 
      }
      
    }

    const budgetBreakDowns = (values,lumpSum) => {
      let breakDownsData = [];
      // if((initial.current==false || newEntry) && values.startDate && values.endDate){
      if(newEntry && values.startDate && values.endDate){
        let startDate=new Date(values.startDate);
        let startMonth=startDate.getMonth()+1;
        let startYear=startDate.getFullYear();
        let endDate=new Date(values.endDate);
        let endMonth=endDate.getMonth();
        let endYear=endDate.getFullYear();
        if(lumpSum){
          /*breakDownsData.push({
            effdate: `${startYear}-${startMonth}-01`,
            enddate: `${endYear}-${endMonth}-01`,
            totalamount: values.totalamount?parseFloat(values.totalamount).toFixed(2):"",
            mmyyyy: `${startMonth}/${startYear}`
          }); */
        }
        else{
          let totalMonth=monthDiff(startDate, endDate);
          
          for (let i = 0; i <= totalMonth; i++) {
            let MM=((startMonth+i)%12==0?12:(startMonth+i)%12);
            let YYYY=startYear;
            
            if((startMonth+i)%12==0){
              startYear+=1;
            }
            var lastDayOfMonth=new Date(YYYY, MM, 0).getDate();
            breakDownsData.push( {
              effdate: `${YYYY}-${MM}-01`,
              enddate: `${YYYY}-${MM}-${lastDayOfMonth}`,
              totalamount: 0,//values.totalamount?(parseFloat(values.totalamount)/totalMonth).toFixed(2):"",
              mmyyyy: `${MM}/${YYYY}`
            });
          }
        }
      }
      else{ 
        if(budgetDetails?.breakdown?.length>0 ){
          let startDate=new Date(budgetDetails.budget.effdate);
          let endDate=new Date(budgetDetails.budget.enddate);
          if(lumpSum){
            /* let MM=startDate.getMonth()+1;
            let YYYY=startDate.getFullYear();
            let eMM=endDate.getMonth()+1;
            let eYYYY=endDate.getFullYear();
            breakDownsData.push({
              effdate: `${YYYY}-${MM}-01`,
              enddate: `${eYYYY}-${eMM}-01`,
              totalamount: values.totalamount?parseFloat(values.totalamount).toFixed(2):"",
              mmyyyy: `${MM}/${YYYY}`
            }); */
          }
          else{
            budgetDetails.breakdown.map(item => {
              // let MM=new Date(item.effdate).getMonth()+1;//startDate.getMonth()+1;
              // let YYYY=startDate.getFullYear();
              let MM=new Date(item.effdate).getMonth()+1;
              let YYYY=new Date(item.effdate).getFullYear();
              let eMM=new Date(item.enddate).getMonth()+1;
              let eYYYY=new Date(item.enddate).getFullYear();
              breakDownsData.push( {
                effdate: `${YYYY}-${MM}-01`,
                enddate: `${eYYYY}-${eMM}-01`,
                totalamount: item.totalamount,//values.totalamount?(parseFloat(values.totalamount)/budgetDetails.breakdown.length).toFixed(2):"",
                mmyyyy: `${MM}/${YYYY}`
              });
            })
          }
          initial.current=false;
        }
      }
      return breakDownsData;
    }
    
    const refreshPreiod= () => {
      var periodsDD=[];
      breakDowns.forEach(element => {
        periodsDD.push({label:element.mmyyyy, value:element.mmyyyy})
      });
      setPeriods(periodsDD)
    }

    const limitSchemeChangeEvent =(value) => {
      setSelectedLimitScheme(value);
      const values={startDate:startEndDate.startDate,endDate:startEndDate.endDate,totalamount:formValue.totalamount};
      var data=budgetBreakDowns(values,value==='lumpsum');
      setBreakDowns(data); 
    }

    function arraysEqual(a, b) {
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length !== b.length) return false;
    
      return JSON.stringify(a)==JSON.stringify(b);
    }

    const updateCfAmount = async () => {
      // periodDetails?periodDetails.cf_totalamount??0.0:0.0
      // Update Budget Cf amount
      // api/corporate/budget/:arnum/:budgetnum
      const user=AuthVerify.getUser();
      if(user && periodDetails){
        const data={
            "budget":{
              "effdate": periodDetails.effdate.split('T')[0],
              "enddate": periodDetails.enddate.split('T')[0],
              "cf_totalamount": cfAmount
            }
        };
        await Axios.post(`/corporate/budget/${user.arnum}/${budgetDetails.budget.budgetnum}`,data)
          .then(async (result) => {
              if (result.status == 200) {
                var responseBudgetData=result.data?.data.budget;
                responseBudgetData.effdate=responseBudgetData.effdate.split('T')[0]
                responseBudgetData.enddate=responseBudgetData.enddate.split('T')[0]
                setBudgetDetails(result.data?.data);
                setFormValue(responseBudgetData);
                setSelectedLimitScheme(result.data?.data.budget.limitscheme);
                setStartEndDate({startDate: result.data?.data.budget.effdate,endDate: result.data?.data.budget.enddate})
                initial.current=true;

                toast.success(`CF amount updated successfully !.`, {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 3000,
                  transition: Slide,
                });
              }
          })
      }
    }

    const BudgetAmountView=() => {
      const values={startDate:startEndDate.startDate,endDate:startEndDate.endDate,totalamount:formValue.totalamount};
      var data=budgetBreakDowns(values);
      if(!arraysEqual(previousValue.current,values)){
        previousValue.current=values;
        setBreakDowns(data); 
      }
      let headerContent = [];
      let bodyContent = [];
      data.forEach(item=>{
        headerContent.push(<th style={{textAlign:"center"}}>{item.mmyyyy}</th>)
        bodyContent.push(
          <td style={{padding:"5px 0px",textAlign:"center",minWidth:"80px"}}>
            <div style={{display:"flex"}}>
              <span className='col-md-2' style={{top:"9px",padding:0,textAlign:"center"}}>S$</span>{" "}
              <input className='col-md-10' type="text" readOnly={!editPermission} style={{maxWidth:"70px", padding:"2px",textAlign:"center"}} defaultValue={item.totalamount} onChange={(e)=>{budgetAmountChangeEvent(item.mmyyyy,e.target.value)}}/>
            </div>
          </td>
        );
      })

      return (
        <table className="data-table" id="my-orders-table">
            <thead>
                <tr className="first last">
                  {headerContent}
                </tr>
            </thead>
            <tbody>
            <tr>
              {bodyContent}
            </tr>
            </tbody>
        </table>
        
      );
      
    }

    return (
        <section className="main-container col1-layout">
          {formValue &&
            <div className="main">
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        <div className="page-content">
                            <div className="page-content checkout-page">
                                <div className="box-border" style={{margin:"auto", maxWidth:"80%"}}>
                                    <h2>Budget Details</h2>
                                    <br/>
                                    <Formik
                                      initialValues={formValue}
                                      validationSchema={validationSchema}
                                      onSubmit={(values, { setSubmitting }) => {
                                        // console.log(values);
                                        updateFormSubmitHandler(values);
                                        // setSubmitting(false);
                                      }}
                                      enableReinitialize
                                    >
                                      {({
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        handleBlur,
                                        handleSubmit,
                                        isSubmitting,
                                        setFieldValue,
                                      }) => (
                                        <form onSubmit={handleSubmit}>
                                          <Col xl={12} sm={12} xs={12}>
                                          <Col xl={12} sm={12} xs={12}>
                                            <Row>
                                              <Col xl={6} sm={6}>
                                                <div className="custom_select">
                                                  <SlectInputField
                                                    Labels="Budget Type"
                                                    Name="budgettype"
                                                    placeHolder="Select Your Type"
                                                    options={budgetTypes}
                                                    value={values.budgettype}
                                                    onChange={e=>{handleChange(e);}}
                                                    onBlur={handleBlur}
                                                    className={
                                                      (errors.budgettype && touched.budgettype
                                                        ? " is-invalid"
                                                        : "")
                                                    }
                                                  />
                                                </div>
                                              </Col>
                                              <Col xl={6} sm={6}>
                                                <InputField
                                                  Name="budgetdesc"
                                                  Labels="Budget Description"
                                                  Type="text"
                                                  ReadOnly={!editPermission}
                                                  value={values.budgetdesc}
                                                  onChange={handleChange}
                                                  isInvalid={!!errors.budgetdesc}
                                                  className={(errors.budgetdesc && touched.budgetdesc) ? 'is-invalid' : 'form-control'}
                                                />
                                              </Col>
                                            </Row>
                                          </Col>
                                                  
                                              <Col xl={12} sm={12}>
                                                <Row>
                                                    <Col sm={6}>
                                                      <InputField
                                                        Labels="Start Date"
                                                        Type="date"
                                                        Name="effdate"
                                                        value={values.effdate}
                                                        onChange={(e)=>{dateChangeEvent(true,false,e.target.value); handleChange(e);}}
                                                        onBlur={handleBlur}
                                                        className={
                                                          "form-control" +
                                                          (errors.effdate && touched.effdate
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                      />
                                                    </Col>
                                                    <Col sm={6}>
                                                      <InputField
                                                        Labels="End Date"
                                                        Type="date"
                                                        Name="enddate"
                                                        value={values.enddate}
                                                        onChange={(e)=>{dateChangeEvent(false,true,e.target.value); handleChange(e);}}
                                                        onBlur={handleBlur}
                                                        className={
                                                          "form-control" +
                                                          (errors.enddate && touched.enddate
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                      />
                                                    </Col>
                                                </Row>
                                              </Col>
                                              
                                              <Col xl={12} sm={12} xs={12}>
                                                <Row>
                                                  <Col xl={6} sm={6}>
                                                    <div className="custom_select">
                                                      <SlectInputField
                                                        Labels="Limit Scheme"
                                                        Name="limitscheme"
                                                        placeHolder="Select Your limit scheme"
                                                        options={limitSchemes}
                                                        value={values.limitscheme}
                                                        onChange={e => { limitSchemeChangeEvent(e.target.value); handleChange(e); }}
                                                        className={
                                                          (errors.limitscheme && touched.limitscheme
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                      />
                                                    </div>
                                                  </Col>
                                                    
                                                  {/* <Col xl={6} sm={6}>
                                                    <div className="custom_select">
                                                      <SlectInputField
                                                        Labels="Apply to catalogs"
                                                        Name="catalognum"
                                                        ReadOnly={!editPermission}
                                                        placeHolder="Select Your Catalog"
                                                        options={catalogs}
                                                        value={values.catalognum}
                                                        onChange={e=>{handleChange(e);}}
                                                        onBlur={handleBlur}
                                                        className={
                                                          (errors.catalognum && touched.catalognum
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                      />
                                                    </div>
                                                  </Col> */}
                                                  <Col xl={6} sm={6}>
                                                    <div className="custom_select">
                                                      <SlectInputField
                                                        Labels="Apply to cost center"
                                                        Name="ccnum"
                                                        ReadOnly={!editPermission}
                                                        placeHolder="Select Your Cost Center"
                                                        emptySelection = {{label:"No Cost Center",value:null}}
                                                        options={costcenter}
                                                        value={values.ccnum}
                                                        onChange={e=>{handleChange(e);}}
                                                        onBlur={handleBlur}
                                                        className={
                                                          (errors.ccnum && touched.ccnum
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </Col>
                                              <Col xl={12} sm={12}>
                                                <Row>
                                                <Col xl={6} sm={6}>
                                                    <InputField
                                                      Name="ponum"
                                                      id="ponum"
                                                      Labels="PO Number"
                                                      Type="text"
                                                      value={values.ponum}
                                                      ReadOnly={!editPermission}
                                                      onChange={handleChange}
                                                      isInvalid={!!errors.ponum}
                                                      className={(errors.ponum && touched.ponum) ? 'is-invalid' : 'form-control'}
                                                    />
                                                  </Col>
                                                </Row>
                                              </Col>

                                              {/* Budget Amount (* For Monthly) */}
                                              {selectedLimitScheme==='monthly' &&
                                              <Col xl={12} sm={12} style={{marginTop:"15px"}}>
                                                <h4>Budget Amount (* For Monthly)</h4>
                                                <div className="recent-orders">
                                                  <Row>
                                                    <Col sm={2} style={{paddingTop:"5%"}}>
                                                      <div className="custom_select">
                                                        Amount Set
                                                      </div>
                                                    </Col>
                                                    <Col sm={10} style={{overflowY:"scroll"}}>
                                                      <BudgetAmountView/>
                                                    </Col>
                                                  </Row>
                                                </div>
                                              </Col>}

                                              {/* Budget Amount (* For Lump Sum) */}
                                              {selectedLimitScheme==='lumpsum' &&
                                              <Col xl={12} sm={12} style={{marginTop:"15px"}}>
                                                <h4>Budget Amount (* For Lump Sum)</h4>
                                                <div style={{textAlign:"left"}}>
                                                  <span className='col-md-1' style={{top:"7px"}}>Total</span>
                                                  <div className='col-md-11'>
                                                    <span style={{top:"7px"}}>S$ </span>
                                                    <input type="text" name="totalamount" onChange={(e)=>{handleChange(e); budgetAmountChangeEvent(false,e.target.value)}} value={values.totalamount}></input>
                                                  </div>
                                                </div>
                                              </Col>}
                                              {editPermission && 
                                              <Col xl={12} sm={12} style={{textAlign:'right'}}>
                                                <button type="submit" className="button">
                                                  {searchParams.get("budgetnum")? "Update Budget":"Create New Budget"}
                                                </button>
                                              </Col>}
                                              {/* Budget Status (*For Monthly) */}
                                              {selectedLimitScheme==='monthly' &&
                                              <Col xl={12} sm={12} style={{marginTop:"15px"}}>
                                                <h4>Budget Status (*For Monthly)</h4>
                                                <div className="recent-orders">
                                                  <br/>
                                                  <Row>
                                                    <Col sm={2}>
                                                      <div className="custom_select">
                                                        Select Period
                                                      </div>
                                                    </Col>
                                                    <Col sm={4}>
                                                      <div className="custom_select">
                                                        <SlectInputField
                                                          Name="period"
                                                          placeHolder="Select Your Period"
                                                          options={periods}
                                                          value={period}
                                                          onChange={e=>{setPeriod(e.target.value);}}
                                                        />
                                                      </div>
                                                    </Col>
                                                    <Col sm={6}>
                                                      <button type='button' style={{padding:"7px 10px"}} onClick={()=>{refreshPreiod();}} >Refresh</button>
                                                    </Col>
                                                  </Row>
                                                  <br/>
                                                  <Row>
                                                    <Col sm={2} style={{paddingTop:"3%"}}>
                                                      <div className="custom_select">
                                                        Amount
                                                      </div>
                                                    </Col>
                                                    <Col sm={10}>
                                                          <table className="data-table" id="my-orders-table">
                                                          <thead>
                                                              <tr className="first last">
                                                                  <th>Brought Forward</th>
                                                                  <th>Allocated</th>
                                                                  <th>Sum</th>
                                                                  <th>Used</th>
                                                                  <th>Pending</th>
                                                                  <th>Balance</th>
                                                                  <th>Carry Forward</th>
                                                              </tr>
                                                          </thead>
                                                          <tbody>
                                                              <tr>
                                                                  <td style={{padding:"6px"}}>
                                                                    <div>
                                                                      <span style={{top:"9px",padding:0,textAlign:"center"}}>S$ {periodDetails?periodDetails.bf_totalamount??0.0:0.0}</span>
                                                                    </div>
                                                                  </td>
                                                                  <td style={{padding:"6px"}}>
                                                                    <div>
                                                                      <span style={{top:"9px",padding:0,textAlign:"center"}}>S$ {periodDetails?periodDetails.totalamount??0.0:0.0}</span>
                                                                    </div>
                                                                  </td>
                                                                  <td style={{padding:"6px"}}>
                                                                    <div>
                                                                      <span style={{top:"9px",padding:0,textAlign:"center"}}>S$ {periodDetails?periodDetails.sum_totalamount??0.0:0.0}</span>
                                                                    </div>
                                                                  </td>
                                                                  <td style={{padding:"6px"}}>
                                                                    <div>
                                                                      <span style={{top:"9px",padding:0,textAlign:"center"}}>S$ {periodDetails?periodDetails.approved_totalamount??0.0:0.0}</span>
                                                                    </div>
                                                                  </td>
                                                                  <td style={{padding:"6px"}}>
                                                                    <div>
                                                                      <span style={{top:"9px",padding:0,textAlign:"center"}}>S$ {periodDetails?periodDetails.pending_totalamount??0.0:0.0}</span>
                                                                    </div>
                                                                  </td>
                                                                  <td style={{padding:"6px"}}>
                                                                    <div>
                                                                      <span style={{top:"9px",padding:0,textAlign:"center"}}>S$ {periodDetails?periodDetails.balance_totalamount??0.0:0.0}</span>
                                                                    </div>
                                                                  </td>
                                                                  <td style={{padding:"6px",maxWidth:"150px"}}>
                                                                    {/* <div>
                                                                      <span style={{top:"9px",padding:0,textAlign:"center"}}>S$ {periodDetails?periodDetails.cf_totalamount??0.0:0.0}</span>
                                                                    </div> */}
                                                                    <div style={{display:"flex"}}>
                                                                      <span className='col-md-2'>S$ </span>
                                                                      <input className='col-md-6' readOnly={!editPermission} type="text" value={cfAmount} onChange={(e)=>setCfAmount(e.target.value)} style={{maxWidth:"100px",padding:0,margin:0}}/>
                                                                      {period && editPermission && <button className='col-md-4' type='button' style={{padding:0}} onClick={()=>updateCfAmount()}>Update</button>}
                                                                    </div>
                                                                  </td>
                                                              </tr>
                                                          </tbody>
                                                      </table>
                                                    </Col>
                                                  </Row>
                                                
                                                </div>
                                              </Col>}

                                              {/* Budget Status (*For Lump Sum) */}
                                              {selectedLimitScheme==='lumpsum' &&
                                              <Col xl={12} sm={12} style={{marginTop:"15px"}}>
                                                <h4>Budget Status (*For Lump Sum)</h4>
                                                <div className="recent-orders">
                                                <table className="data-table" id="my-orders-table">
                                                    <thead>
                                                        <tr className="first last">
                                                            <th>Allocation</th>
                                                            <th>Used</th>
                                                            <th>Pending</th>
                                                            <th>Balance</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{padding:0}}>
                                                              <div style={{display:"flex"}}>
                                                                <span style={{top:"9px",padding:0,textAlign:"center"}}>S$ {budgetDetails?.breakdown?.[0]?.totalamount??0.0}</span>
                                                              </div>
                                                            </td>
                                                            <td style={{padding:0}}>
                                                              <div style={{display:"flex"}}>
                                                                <span style={{top:"9px",padding:0,textAlign:"center"}}>S$ {budgetDetails?.breakdown?.[0]?.approved_totalamount??0.0}</span>
                                                              </div>
                                                            </td>
                                                            <td style={{padding:0}}>
                                                              <div style={{display:"flex"}}>
                                                                <span style={{top:"9px",padding:0,textAlign:"center"}}>S$ {budgetDetails?.breakdown?.[0]?.pending_totalamount??0.0}</span>
                                                              </div>
                                                            </td>
                                                            <td style={{padding:0}}>
                                                              <div style={{display:"flex"}}>
                                                                <span style={{top:"9px",padding:0,textAlign:"center"}}>S$ {budgetDetails?.breakdown?.[0]?.balance_totalamount??0.0}</span>
                                                              </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                </div>
                                              </Col>}

                                              <Col xl={12} sm={12} style={{textAlign:'right'}}>
                                                <button className="button" type="button" onClick={()=>navigate('/my-account?activeKey=Budget')}><span>Back to Budget Listing</span></button>
                                                {/* <button type="submit" className="button">
                                                  {newEntry? "Create New Budget" :"Update Budget"}
                                                </button> */}
                                              </Col>
                                          </Col>
                                        </form>
                                      )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
          }
        </section >

    )
}

export default BudgetDetails